const buildXhrWithProgressUpdate = ({ onProgress }) => {
  return function() {
    const xhr = new window.XMLHttpRequest()

    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable && onProgress) onProgress(e.loaded)
    }, false)

    return xhr
  }
}

export default function uploadImage({ file, onProgress }) {
  const formData = new FormData()
  formData.append('image', file)

  return new Promise((resolve, reject) => {
    $.ajax({
      url: '/api/burosfera/vacancy_images',
      data: formData,
      contentType: false,
      processData: false,
      type: 'POST',
      xhr: buildXhrWithProgressUpdate({ onProgress }),
      success: res => resolve(res),
      error: xhr => reject(xhr),
    })
  })
}
